/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ state: NonNullable<unknown> }} Actuator_StateInputs */



/**
* | state | output |
* | --- | --- |
* | "auto" | "Auto" |
* | "forcing" | "Forcing" |
* | "manual" | "Manual" |
* | "unknown" | "Unknown" |
* | * | "Unknown" |
*
* @param {Actuator_StateInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const actuator_state = /** @type {((inputs: Actuator_StateInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actuator_StateInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.state === "auto") return /** @type {LocalizedString} */ (`Auto`);
		if (i?.state === "forcing") return /** @type {LocalizedString} */ (`Forcing`);
		if (i?.state === "manual") return /** @type {LocalizedString} */ (`Manual`);
		if (i?.state === "unknown") return /** @type {LocalizedString} */ (`Unknown`);
		return /** @type {LocalizedString} */ (`Unknown`)
	}
	{
		if (i?.state === "auto") return /** @type {LocalizedString} */ (`Auto`);
		if (i?.state === "forcing") return /** @type {LocalizedString} */ (`Forçage`);
		if (i?.state === "manual") return /** @type {LocalizedString} */ (`Manuel`);
		if (i?.state === "unknown") return /** @type {LocalizedString} */ (`Inconnu`);
		return /** @type {LocalizedString} */ (`Inconnu`)
	}
});